module.exports = __webpack_public_path__ + "img/BG-平台介绍.a5e04d36.png";